import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import Button from 'components/Button';
import Utils from '../../../utils/Utils';
import GTM from '../../../utils/GTM';
import TableView from '../components/TableView';
import WidgetForm from '../components/WidgetForm';
import ReserveForm from 'modules/Adventure/components/ReserveForm';
import WidgetSuccess from '../components/WidgetSuccess';
import offLogo from '../../../assets/img/logo-offstation-200x35.png'
import './RequestWidget.scss';
import 'moment/locale/pt-br';
import { ToastContainer, toast } from 'react-toastify';
import Metrics from '../../../utils/Metrics';

@inject('AdventuresStore', 'RequestStore', 'CheckoutStore', 'ApplicationStore', 'AuthStore')
@observer
class TableWidget extends Component {

  constructor(props) {
    super(props)
    const urlParams = Utils.getAllUrlParams(window.location.href);
    const enable = urlParams.enable
    const textColor = urlParams.textcolor || ''
    const primaryColor = urlParams.primarycolor || ''
    const backgroundColor = urlParams.backgroundcolor || ''
    const fkPartner = urlParams.fkpartner || ''
    const pkUser = urlParams.pkuser || undefined

    this.state = {
      step: 1,
      firstLoading: true,
      visibleDates: [],
      backgroundColor,
      fkPartner,
      primaryColor,
      textColor,
      pkUser,
      enable,
      terms: false
    }

    this.loadSchedule = this.loadSchedule.bind(this)
    this.handleSetDate = this.handleSetDate.bind(this)
    this.handleSetHour = this.handleSetHour.bind(this)
    this.buildDates = this.buildDates.bind(this)
    this.handleSelectAdventure = this.handleSelectAdventure.bind(this)
    this.handleGoStepOne = this.handleGoStepOne.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.makeRequest = this.makeRequest.bind(this)
    this.handleComplete = this.handleComplete.bind(this)
    this.goToCheckout = this.goToCheckout.bind(this)
  }

  componentDidMount() {
    const { AdventuresStore, RequestStore, ApplicationStore, AuthStore } = this.props;

    RequestStore.setWidget();
    if (this.state.pkUser) {
      AuthStore.loginByPk(this.state.pkUser);
    }

    AdventuresStore.getAdventuresByCompany({
      name: this.props.match.params.id,
    }, this.state.enable).then(() => {
      ApplicationStore.setTagCode(AdventuresStore.CompanyAdventures[0].company_tag_code)
      const schedulePromises = AdventuresStore.CompanyAdventures.map(adventure => this.loadSchedule(adventure.nextDate, adventure.pkAdventure))
      const requestsPromises = AdventuresStore.CompanyAdventures.map(adventure => {
        const firstDate = AdventuresStore.CompanyAdventures.reduce((currDate, adventure) => {
          if (!currDate || moment(currDate).isAfter(moment(adventure.nextDate)) && !!adventure.nextDate) {
            return adventure.nextDate
          }
          return currDate
        }, undefined)

        this.handleSetDate(moment(firstDate).toDate())
        this.buildDates(firstDate)

        return RequestStore.getAdventureRequests(adventure.pkAdventure)
          .then(requests => AdventuresStore.setCompanyAdventureRequests(requests, adventure.pkAdventure))
      })

      Promise.all([...schedulePromises, ...requestsPromises])
        .then(() => {
          Metrics.triggerLoadSchedule({ fk_company: AdventuresStore.CompanyAdventures[0].fkCompany, fk_adventures: AdventuresStore.CompanyAdventures.map(item => item.pAdventure) })
          this.setState({
            firstLoading: false
          })
        })
        .catch(() => this.setState({
          firstLoading: false
        }))
    }).catch(() => {
      RequestStore.setFirstLoadingGetSchedule(false)
      this.setState({
        firstLoading: false
      })
    })

    this.adjustOverflow();
    window.addEventListener('resize', this.adjustOverflow); // Ajusta o overflow ao redimensionar a janela
  }

  componentDidUpdate() {
    this.adjustOverflow();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustOverflow); // Limpa o event listener ao desmontar
  }

  buildDates(date) {
    const dates = [];

    for (let i = 0; i <= 6; i++) {
      const curDate = moment(date).add(i, 'days')
      dates.push(curDate)

    }

    this.setState({ visibleDates: dates })
  }

  loadSchedule(date, pkAdventure) {
    const { RequestStore } = this.props

    return RequestStore.getAllHoursOfAdventureByDate(moment(date).toDate(), pkAdventure)
      .then(() => {
        const nextMonth = moment(date).add('1', 'month').toDate();
        return RequestStore.getAllHoursOfAdventureByDate(nextMonth, pkAdventure)
        // .then(() => {
        //   const newNextMonth = moment(nextMonth).add('1', 'month').toDate();
        //   return RequestStore.getAllHoursOfAdventureByDate(newNextMonth, pkAdventure)
        // })
      })
  }

  getRequestParams() {
    const { RequestStore } = this.props;
    const { pk_schedule_rule } = RequestStore.hour
    const request = RequestStore.getCurrentRequest();
    const data = !!request && request.pk_request ? { pk_request: request.pk_request } : { pk_schedule_rule }

    return {
      date: moment(RequestStore.date).format('YYYY-MM-DD'),
      hour: RequestStore.hour,
      voucherSelected: RequestStore.voucherSelected,
      isRequest: !!RequestStore.isPaymentForRequest,
      type: RequestStore.activeButton,
      url_name: RequestStore.adventure.urlName,
      pkRuleTime: RequestStore.pkRuleTime,
      pkPackage: RequestStore.getSelectedPackage.pkPackage,
      fkAdventure: RequestStore.getSelectedPackage.fkAdventure,
      requestPackagesParams: data,
      packages: RequestStore.avaiablePackages.filter(p => p.quantity),
      fkPartner: this.state.fkPartner
    };

  }

  goToCheckout() {
    const { RequestStore, CheckoutStore } = this.props;
    const params = this.getRequestParams()
    // localStorage.setItem('requestParams', JSON.stringify(params));
    CheckoutStore.registerCheckoutData(params).then(() => {
      GTM.dispatch(GTM.EVENT_SELECT_PACKAGES)
      const url = `${RequestStore.adventure.urn}/checkout?cart=${CheckoutStore.pk_cart}&fkPartner=${this.state.fkPartner}`
      const newWindow = window.open(url, '_blank');
      if (!newWindow || newWindow.closed || newWindow.closed === undefined)
        window.top.location.replace(url);
    })
  }

  handleComplete() {
    const { RequestStore } = this.props
    const request = RequestStore.getCurrentRequest();
    if (RequestStore.adventure.only_public || RequestStore.isPaymentForRequest || RequestStore.adventure.voucher_enabled || (!!request && request.type == 1)) {
      //GTM.dispatch('reservaPorWidget')
      this.goToCheckout()
    } else {
      //GTM.dispatch('agendamentoPorWidget')
      this.makeRequest()
    }
  }

  makeRequest() {
    const { RequestStore } = this.props

    const params = this.getRequestParams()
    localStorage.setItem('requestParams', JSON.stringify(params));

    const payload = {
      date: `${moment(RequestStore.date).format('YYYY-MM-DD')} ${RequestStore.hour.value}:00`,
      name: RequestStore.fields.find(f => f.title === 'Nome completo').value,
      email: RequestStore.fields.find(f => f.title === 'Email').value,
      phone: RequestStore.fields.find(f => f.title === 'Celular').value,
      observation: RequestStore.fields.find(f => f.title === 'Observação') && RequestStore.fields.find(f => f.title === 'Observação').value,
      pkAdventure: RequestStore.adventure.pkAdventure,
      pk_schedule_rule: RequestStore.hour.pk_schedule_rule,
      widget: true,
      fields: RequestStore.fields.filter(f => f.title !== 'Nome completo' && f.title !== 'Email' && f.title !== 'Celular' && f.title !== 'Observação')
    }

    RequestStore.submitRequest(payload).then(res => {
      if (res.success === true) {
        GTM.dispatch(GTM.EVENT_CREATE_REQUEST)
        this.setState({ step: this.state.step + 1 })
      } else {
        toast(res.data.message);
      }
    }).catch(err => {
      toast(err.data.message);
    })
  }

  handleSetDate(date) {
    const { RequestStore } = this.props;
    RequestStore.setDate(date);
    RequestStore.removeHour();
  }

  handleSetHour(hour) {
    const { RequestStore } = this.props;
    RequestStore.handleSetHour(hour);
  }

  handleSelectAdventure(pkAdventure) {
    const { RequestStore, AdventuresStore } = this.props;
    const adventure = AdventuresStore.CompanyAdventures.find(adv => adv.pkAdventure === pkAdventure)
    RequestStore.setAdventure(adventure)
    RequestStore.getCustomFields();
    if (!RequestStore.getSelectedPackage) {
      RequestStore.selectFirstPackage();
    }
  }

  handleGoStepOne() {
    this.setState({ step: 1 })
  }

  handleNext(e) {
    const { step } = this.state;
    switch (step) {
      case 1:
        this.setState({ step: step + 1 }, () => {
          this.dispatchHourSelected();
          window.scrollTo(0, 0);
          window.parent.postMessage('scrollToTop', '*')
        });
        break;
      case 2:
        this.handleComplete();
        window.scrollTo(0, 0);
        window.parent.postMessage('scrollToTop', '*')
        break;
      default:
        break;
    }
  }

  dispatchHourSelected() {
    const { hour, date, adventure } = this.props.RequestStore
    Metrics.triggerHourSelected({ fk_company: adventure.fkCompany, pk_adventure: adventure.pkAdventure })
    GTM.dispatch(GTM.EVENT_SELECT_HOUR, {
      adventure: adventure.title,
      date: moment(date).format("HH:mm DD/MM/YYYY")
    })
  }

  adjustOverflow = () => {
    const contentHeight = document.documentElement.scrollHeight;
    const viewportHeight = window.innerHeight;
    if (contentHeight <= viewportHeight) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'auto';
    }
  }

  render() {
    const { RequestStore, AdventuresStore, CheckoutStore } = this.props;
    const { visibleDates, step, terms } = this.state
    const Adventure = RequestStore.adventure;
    const request = RequestStore.getCurrentRequest();
    let content = ''
    let readyToContinueWidget = false
    let showReserveForm = false
    if (Adventure)
      showReserveForm = (Adventure.only_public || Adventure.voucher_enabled || RequestStore.isPaymentForRequest) || (!!request && request.type == 1)
    switch (step) {
      case 1:
        content = (
          <TableView
            adventures={AdventuresStore.CompanyAdventures}
            visibleDates={visibleDates}
            selectedDate={RequestStore.date}
            selectedHour={RequestStore.hour}
            vancancies={RequestStore.getAvailableVacancies()}
            getPeople={(adv, req) => RequestStore.getRequestPeople(adv, req)}
            getVancancies={(adventure, hour) => RequestStore.getVacanciesInHour(adventure, hour)}
            buildDates={this.buildDates}
            handleSetDate={this.handleSetDate}
            onContinue={this.handleNext}
            handleSetHour={this.handleSetHour}
            loadSchedule={this.loadSchedule}
            backgroundColor={this.state.backgroundColor}
            textColor={this.state.textColor}
            primaryColor={this.state.primaryColor}
            firstLoadingGetSchedule={RequestStore.firstLoadingGetSchedule}
            firstLoading={this.state.firstLoading}
            schedule={RequestStore.schedule}
            selectAdventure={this.handleSelectAdventure}
            selectedAdventure={Adventure}
            getRequestsInHour={(hour, date, adventure) => RequestStore.getAllRequestsInHour(hour, date, adventure)}
          />
        )
        readyToContinueWidget = RequestStore.hour && !!RequestStore.hour.value
        break;
      case 2:
        content = (
          <WidgetForm
            adventure={Adventure}
            selectedDate={RequestStore.date}
            selectedHour={RequestStore.hour}
            onGoBack={this.handleGoStepOne}
            fields={RequestStore.fields}
            onChange={(v, i) => RequestStore.handleChangeField(v, i)}
            toggleTermsChecked={() => this.setState({ terms: !this.state.terms })}
            termsChecked={terms}
            loadingFormsFields={RequestStore.isLoadingFields}
            privacyChecked={CheckoutStore.privacyChecked}
            togglePrivacyChecked={() => CheckoutStore.togglePrivacyChecked()}
            privacyTerm={Adventure.privacyTerm}
          >
            {
              showReserveForm ?
                <ReserveForm
                  isDateSelected={RequestStore.isDateSelected}
                  isHourSelected={RequestStore.isHourSelected}
                  packagesCount={RequestStore.packagesCount}
                  isVoucherSelected={RequestStore.voucherSelected}
                  isForRequest={RequestStore.isPaymentForRequest}
                  packages={RequestStore.avaiablePackages}
                  loadingPackages={RequestStore.loadingPackages}
                  loadingContinue={CheckoutStore.registeringCart}
                  cancel_rules={Adventure.cancel_rules}
                  request={RequestStore.request}
                  isMobile={false}
                  isModal={false}
                  buttonAlign='right'
                  onContinue={() => this.handleComplete()}
                  handleRemovePackage={(pkPackage) => RequestStore.removePackage(pkPackage)}
                  handleAddPackage={(pkPackage) => RequestStore.addPackage(pkPackage)}
                  canAddPackage={(pkPackage) => RequestStore.canAddPackage(pkPackage)}
                  canRemovePackage={RequestStore.canRemovePackage}
                  vacancies={RequestStore.getAvailableVacancies()}
                  privacyTerm={Adventure.privacyTerm}
                /> : ''
            }
          </WidgetForm>
        )
        readyToContinueWidget = RequestStore.fields.filter(f => f.validator(f.value)).length === 0
        if (Adventure.terms_on_request)
          readyToContinueWidget &= !!this.state.terms

        if (showReserveForm)
          readyToContinueWidget &= RequestStore.packagesCount > 0

        readyToContinueWidget &= CheckoutStore.privacyChecked

        break;
      case 3:
        content = (
          <WidgetSuccess request={RequestStore.request} success_message={Adventure.request_success_message} />
        )
        break;
      default:
        content = ''
        break;
    }


    return (
      <div className="RequestWidget">
        <style dangerouslySetInnerHTML={{
          __html: `
          
              body {
                background-color: #${this.state.backgroundColor};
                display: flex;
              }

              // .GridView .hour-column .hour-card .modal-selected-date.visible {
              //   color: #${this.state.textColor} !important;
              //   background-color: #${this.state.backgroundColor};
              // }

              .GridView .hour-column .hour-card .modal-selected-date .modal-text .vacancies { 
                color: #${this.state.primaryColor};
              }
  
              .carousel-dates .date-card,
              .hour-column .hour-card .hour-content {
                border-color: #${this.state.textColor}50 !important;
              }
  
              .carousel-dates .date-card.selected,
              .hour-column .hour-card .hour-content.selected {
                border-color: #${this.state.primaryColor} !important;
                background-color: #${this.state.primaryColor} !important;
              }
  
              .CalendarDay--selected-start,
              .CalendarDay--selected-end,
              .CalendarDay--selected {
                background-image: ${(this.state.primaryColor) ? 'none' : ''} !important;
              }
  
              .PageLoader .loader .loader-ball {
                background-color: #${this.state.textColor};
              }

              .CalendarDay--selected-start,
              .CalendarDay--selected-end,
              .CalendarDay--selected,
              .RequestWidget .btn {
                background-color: #${this.state.primaryColor};
              }

              .RequestWidget .btn.disabled,
              .hour-column .hour-card .hour-content.disabled {
                background-color: #${this.state.textColor}12 !important;
              }

              .RequestWidget .btn.disabled,
              .hour-column .hour-card .hour-content.disabled {
                color: #${this.state.textColor}33 !important;
              }
  
              .hour-column .hour-card .hour-content.disabled {
                border-color: #${this.state.textColor}05 !important;
              }

              .carousel-dates .date-card,
              .more-dates,
              .hour-column .hour-card .hour-content,
              .GridView h3,
              .GridView .adventure-title,
              .header-labels .label,
              .WidgetForm h3,
              .WidgetForm .terms,
              .WidgetForm .group label,
              .WidgetForm .group input,
              .WidgetForm .group textarea,
              .concordo,
              .text-pink small,
              .Dropdown .dropdown-value,
              .WidgetSuccess h2,
              .WidgetSuccess .wrapper p,
              .WidgetSuccess .wrapper .copy-div input,
              .WidgetSuccess .Grid2 .GridItem2,
              .package-info-row,
              .MuiInputBase-input,
              .side-checkout-link {
                color: #${this.state.textColor} !important;
              }

              .WidgetForm h3+p,
              .WidgetForm .header .go-back,
              .hour-card-nodata {
                color: #${this.state.textColor}80 !important;
              }

              .card-text-confirmed {
                color: #${this.state.primaryColor};
              }

              .more-dates {
                color: #${this.state.primaryColor} !important;
              }

              .Dropdown .dropdown-value .icon-dropdown {
                color: #${this.state.primaryColor} !important;
              }

              .GridView .slick-next:before, 
              .GridView .slick-prev:before,
              .text-pink a,
              .text-pink i {
                color: #${this.state.primaryColor} !important;
              }

              .WidgetForm .group input,
              .WidgetForm .group textarea,
              .Dropdown .dropdown-value {
                background-color: transparent !important;
              }

              input:-webkit-autofill,
              input:-webkit-autofill:hover, 
              input:-webkit-autofill:focus, 
              input:-webkit-autofill:active  {
                  -webkit-box-shadow: 0 0 0 30px #${this.state.backgroundColor.substring(0, 6)} inset !important;
                  -webkit-text-fill-color: #${this.state.textColor} !important;
              }

              .package-quantity .minus, .package-quantity .plus {
                color: #${this.state.primaryColor} !important;
                border-color: #${this.state.primaryColor} !important;
              }

              .package-quantity .number {
                color: #${this.state.textColor} !important;
              }

              .Dropdown .list-dropdown {
                top: 35px !important;
                padding: 0 !important;
              }

              .Dropdown .list-dropdown .item {
                margin-left: 20px;
                margin-right: 20px;
              }

            `
        }} />
        <ToastContainer
          position="top-right"
          type="default"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
        />
        <div className="content">
          {content}
        </div>
        {this.state.step !== 3 && this.state.step !== 1 && !this.state.firstLoading && !(RequestStore.adventure && (RequestStore.adventure.only_public || RequestStore.adventure.voucher_enabled || RequestStore.isPaymentForRequest || (!!request && request.type == 1))) &&
          <Button
            loading={RequestStore.loading}
            size='lg' type='primary'
            disabled={!readyToContinueWidget}
            onClick={this.handleNext}
          >{RequestStore.loading ? <span className='fa fa-spinner fa-spin'></span> : 'Reservar horário'}</Button>
        }
        <div style={{ opacity: 0.3, bottom: 0, right: '5%', textAlign: "right", fontSize: "8px", textTransform: "uppercase", letterSpacing: "0.8px" }}>
          <span style={{ display: "block", paddingRight: "16px", fontFamily: "sans-serif", color: "#333", marginTop: "10px" }}>Powered by</span>
          <a href="https://www.offstation.com.br/" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", margin: "0 auto" }}>
            <img src={offLogo} alt="Powered By Offstation" style={{ width: "102px", height: "18px" }} />
          </a>
        </div>
      </div>
    )
  }
}

export default TableWidget;